import { useQuery } from "@tanstack/react-query"
import { apiClient } from "../helpers/Axios"

export const useUser = () => {
    return useQuery({
        queryKey: ['user'],
        queryFn: async () => {
            const res = await apiClient.get('/auth/user');
            return res.data
        },
        refetchInterval: 50000,
    })
}